'use client';

import CustomLink from 'components/shared/CustomLink';
import { SplineViewer } from 'components/shared/SplineViewer/SplineViewer';
import { useSearchParams } from 'next/navigation';
import { useWindowSize } from 'hooks/dom/useWindowSize';
import { analytics } from 'lib/analytics/analytics';
import { getAssetUrl } from 'lib/config/assetUrls';
import styles from './HeroSection.module.css';

export const SizingKit_HeroSection = () => {
  const searchParams = useSearchParams();
  const { width } = useWindowSize();

  return (
    <section className={styles.root}>
      <div className={styles.canvasContainer}>
        <SplineViewer
          desktopSrc="/js/dark-rings-desktop.splinecode"
          mobileSrc="/js/dark-rings-responsive.splinecode"
        />
      </div>

      <div className={styles.mainContent}>
        <h1>
          Skip the wait,
          <br />
          print the fit.
        </h1>
        <p className={styles.subtitle}>
          Print your at-home 3D ring sizing kit with ease.
          {width > 767 ? <br /> : null} Download, print, and discover your ideal
          ring size in minutes.
        </p>
        <div className={styles.ctaContainer}>
          <CustomLink
            download
            href={{
              pathname: getAssetUrl(
                '/web_v2/downloads/3D%20print%20your%20Ultrahuman%20Ring%20Sizing%20Kit%20.zip',
              ),
              query: Object.fromEntries(searchParams?.entries() ?? []),
            }}
            title="3D print your Ultrahuman Ring Sizing Kit.zip"
            className={`${styles.primary} ${styles.downloadBtn}`}
            onClick={() =>
              analytics.track('download-air-sizing-kit-design-files', {
                clicked: true,
              })
            }
          >
            <span> Download the design file</span>{' '}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="14"
              viewBox="0 0 12 14"
              fill="none"
            >
              <path
                d="M5.9996 0.499939C5.75328 0.499939 5.51705 0.597789 5.34288 0.771963C5.1687 0.946137 5.07085 1.18237 5.07085 1.42869V8.11567L2.90378 6.28913C2.81156 6.20513 2.70328 6.14071 2.58546 6.09975C2.46764 6.05879 2.34274 6.04215 2.21831 6.05083C2.09388 6.05951 1.9725 6.09333 1.86151 6.15026C1.75052 6.20718 1.65223 6.28602 1.57257 6.38201C1.48857 6.47422 1.42415 6.58251 1.38319 6.70032C1.34223 6.81814 1.32559 6.94304 1.33427 7.06747C1.34295 7.19191 1.37677 7.31328 1.4337 7.42427C1.49062 7.53526 1.56946 7.63355 1.66545 7.71321L5.38043 10.809C5.45518 10.8639 5.53625 10.9097 5.62191 10.9453H5.65906C5.84744 11.0113 6.0527 11.0113 6.24107 10.9453H6.27822C6.36388 10.9097 6.44495 10.8639 6.5197 10.809L10.2347 7.71321C10.3825 7.58956 10.4882 7.42301 10.5371 7.23663C10.586 7.05024 10.5757 6.85326 10.5077 6.67298C10.4396 6.49269 10.3172 6.33803 10.1574 6.23043C9.99752 6.12283 9.80816 6.06761 9.61552 6.07242C9.38946 6.06578 9.16893 6.14297 8.99636 6.28913L6.80451 8.14663V1.42869C6.80653 1.20239 6.72586 0.983148 6.57765 0.812134C6.42944 0.641119 6.22388 0.530104 5.9996 0.499939Z"
                fill="black"
              />
              <path
                d="M0.737305 12.5713C0.737305 12.8176 0.835155 13.0538 1.00933 13.228C1.1835 13.4022 1.41973 13.5 1.66605 13.5H10.3344C10.5807 13.5 10.8169 13.4022 10.9911 13.228C11.1653 13.0538 11.2631 12.8176 11.2631 12.5713C11.2631 12.3249 11.1653 12.0887 10.9911 11.9145C10.8169 11.7404 10.5807 11.6425 10.3344 11.6425H1.66605C1.41973 11.6425 1.1835 11.7404 1.00933 11.9145C0.835155 12.0887 0.737305 12.3249 0.737305 12.5713Z"
                fill="black"
              />
            </svg>
          </CustomLink>
        </div>
      </div>
    </section>
  );
};
